import type { MemberRequest, MemberResponse } from "@/types/codegen/data-contracts"

export type MemberRegistrationPayload = {
  data: MemberRequest["data"]
  signatureDataUrl?: string
  signatureFileName?: string
}

export type MemberRegistrationResponse = {
  member: MemberResponse
  signatureId?: number | string
}

export const postMemberRegistration = async (
  payload: MemberRegistrationPayload,
): Promise<MemberRegistrationResponse> => {
  const response = await fetch("/api/member-registration", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => null)
    throw new Error(error?.message || "Failed to submit member registration")
  }

  return response.json()
}
